import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { Icon } from '../../Atoms/Icon';
import { useSmallScreen } from '../../lib/hooks';

const TableFooter = ({ table, pageSizeArr }) => {
  const isSmallScreen = useSmallScreen();
  return (
    <Row noGutters className="align-items-center bg-gray-200 py-2">
      <Col xs={2}>
        <Button
          size="sm"
          variant="link"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          className="text-uppercase align-items-center d-flex"
        >
          <Icon name="arrow-left" className="mr-1" /> Back
        </Button>
      </Col>
      <Col className="text-center">
        <Form className="d-inline-flex">
          <Form.Row className="align-items-center">
            <Col xs="auto">Page</Col>
            <Col xs="auto">
              <Form.Control
                as="select"
                style={{}}
                value={table.getState().pagination.pageIndex + 1}
                onChange={(e) => {
                  table.setPageIndex(Number(e.target.value) - 1);
                }}
              >
                {Array.from(
                  { length: table.getPageCount() },
                  (_, i) => i + 1,
                ).map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col xs="auto">of {table.getPageCount()}</Col>
            {!isSmallScreen && (
              <Col xs="auto">
                <Form.Control
                  as="select"
                  value={table.getState().pagination.pageSize}
                  onChange={(e) => {
                    table.setPageSize(Number(e.target.value));
                  }}
                >
                  {pageSizeArr.map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize} rows
                    </option>
                  ))}{' '}
                </Form.Control>
              </Col>
            )}
          </Form.Row>
        </Form>
      </Col>

      <Col className="text-right" xs={2}>
        <Button
          size="sm"
          variant="link"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          className="text-uppercase align-items-center d-flex float-right"
        >
          Next <Icon name="arrow-right" className="ml-1" />
        </Button>
      </Col>
      {isSmallScreen && (
        <Col xs={12} className="mt-5 px-4">
          <Form.Control
            as="select"
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              table.setPageSize(Number(e.target.value));
            }}
          >
            {pageSizeArr.map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize} rows per page
              </option>
            ))}{' '}
          </Form.Control>
        </Col>
      )}
    </Row>
  );
};
TableFooter.propTypes = {
  table: PropTypes.shape({
    getAllFlatColumns: PropTypes.func,
    getCanPreviousPage: PropTypes.func,
    setPageSize: PropTypes.func,
    getState: PropTypes.func,
    getPageCount: PropTypes.func,
    getCanNextPage: PropTypes.func,
    previousPage: PropTypes.func,
    setPageIndex: PropTypes.func,
    nextPage: PropTypes.func,
  }),
  pageSizeArr: PropTypes.arrayOf(PropTypes.number),
};
export default TableFooter;
